export { default } from './Home24Parceiros';
